import React from "react";
import MyRouter from "routers/index";

function App() {
  if (!localStorage.getItem("theme"))
    localStorage.setItem("theme", "dark");
  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <MyRouter />
    </div>
  );
}

export default App;
